import { articles } from '@/mocks/articles';
import ArticleCard from '@/components/base/ArticleCard';
import { Link } from 'react-router-dom';

export default function LatestArticles() {
  const latestArticles = articles.slice(0, 5);
  const featured = latestArticles[0];
  const rest = latestArticles.slice(1);

  return (
    <section className="py-16 md:py-20 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-12">
          <div>
            <span className="text-xs font-semibold text-primary-500 uppercase tracking-wider">
              深度评测
            </span>
            <h2 className="mt-3 text-2xl md:text-3xl font-heading font-bold text-foreground-800">
              最新文章与指南
            </h2>
          </div>
          <Link
            to="/category/guide"
            className="hidden sm:inline-flex items-center gap-2 text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200 cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
          <ArticleCard {...featured} featured />

          <div className="flex flex-col gap-5">
            {rest.map((article) => (
              <ArticleCard key={article.slug} {...article} />
            ))}
          </div>
        </div>

        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/guide"
            className="inline-flex items-center gap-2 px-6 py-3 border border-primary-500/30 text-primary-500 rounded-lg hover:bg-primary-500/10 transition-all duration-300 cursor-pointer text-sm font-medium"
          >
            查看全部文章
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}